import axios from 'axios';
import { createErr, createOk, Result } from '../types/result';
import { constructUrl } from './utils';

import {
  ReleaseComponent,
  ReleaseComponentApi,
  isReleaseComponents,
} from '../types/releaseComponent';

import {
  ReleaseEnvironment,
  isReleaseEnvironments,
} from '../types/releaseEnvironment';

import {
  ReleaseTask,
  isReleaseTasks,
  isTargetGroups,
} from '../types/releaseTask';

/**
 * コンポーネント機能
 */

const COMPONENT_URL = '/v1/release/components';

/** 一覧取得 */

export const fetchReleaseComponents = async (): Promise<
  Result<ReleaseComponentApi[], Error>
> =>
  axios
    .get(constructUrl(COMPONENT_URL))
    .then(({ data }: { data: unknown }) => {
      if (!isReleaseComponents(data)) {
        throw Error(`Unsupported Value: ${JSON.stringify(data)}`);
      }

      return createOk(data);
    })
    .catch((err: Error) => createErr(err));

/** 新規登録 */
export const addComponent = async (
  payload: ReleaseComponentApi,
): Promise<Result<ReleaseComponent, Error>> =>
  axios
    .post(constructUrl(COMPONENT_URL), payload)
    .then(({ data }) => createOk(data))
    .catch((err: Error) => createErr(err));

/** 削除 */
export const deleteComponent = async (
  id: number,
): Promise<Result<null, Error>> =>
  axios
    .delete(constructUrl(`${COMPONENT_URL}/${id}`))
    .then(() => createOk(null))
    .catch((err: Error) => createErr(err));

/** 更新 */
export const editComponent = async (
  id: number,
  payload: ReleaseComponentApi,
): Promise<Result<ReleaseComponent, Error>> =>
  axios
    .put(constructUrl(`${COMPONENT_URL}/${id}`), payload)
    .then(({ data }) => createOk(data))
    .catch((err: Error) => createErr(err));

/**
 * 環境機能
 */

const ENVIRONMENT_URL = '/v1/release';

/** 一覧取得 */

export const fetchReleaseEnvironments = async (): Promise<
  Result<ReleaseEnvironment[], Error>
> =>
  axios
    .get(constructUrl(ENVIRONMENT_URL))
    .then(({ data }: { data: unknown }) => {
      if (!isReleaseEnvironments(data)) {
        throw Error(`Unsupported Value: ${JSON.stringify(data)}`);
      }

      return createOk(data);
    })
    .catch((err: Error) => createErr(err));

/** 新規登録 */
export const addEnvironment = async (
  payload: ReleaseEnvironment,
): Promise<Result<ReleaseEnvironment, Error>> =>
  axios
    .post(constructUrl(ENVIRONMENT_URL), payload)
    .then(({ data }) => createOk(data))
    .catch((err: Error) => createErr(err));

/** 削除 */
export const deleteEnvironment = async (
  environmentId: string,
): Promise<Result<null, Error>> =>
  axios
    .delete(constructUrl(`${ENVIRONMENT_URL}/${environmentId}`))
    .then(() => createOk(null))
    .catch((err: Error) => createErr(err));

/** 更新 */
export const editEnvironment = async (
  environmentId: string,
  payload: ReleaseEnvironment,
): Promise<Result<ReleaseEnvironment, Error>> =>
  axios
    .put(constructUrl(`${ENVIRONMENT_URL}/${environmentId}`), payload)
    .then(({ data }) => createOk(data))
    .catch((err: Error) => createErr(err));

/** ターゲットグループ選択用 */
export const fetchTargetGroup = async (): Promise<Result<string[], Error>> =>
  axios
    .get(constructUrl(`${ENVIRONMENT_URL}/group`))
    .then(({ data }: { data: unknown }) => {
      if (!isTargetGroups(data)) {
        throw Error(`Unsupported Value: ${JSON.stringify(data)}`);
      }

      return createOk(data);
    })
    .catch((err: Error) => createErr(err));

/**
 * タスク機能
 */

const TASK_URL = '/v1/release/update-task';

/** 一覧取得 */

export const fetchReleaseTasks = async (): Promise<
  Result<ReleaseTask[], Error>
> =>
  axios
    .get(constructUrl(TASK_URL))
    .then(({ data }: { data: unknown }) => {
      if (!isReleaseTasks(data)) {
        throw Error(`Unsupported Value: ${JSON.stringify(data)}`);
      }

      return createOk(data);
    })
    .catch((err: Error) => createErr(err));

/** 新規登録 */
export const addTask = async (
  payload: ReleaseTask,
): Promise<Result<ReleaseTask, Error>> =>
  axios
    .post(constructUrl(TASK_URL), payload)
    .then(({ data }) => createOk(data))
    .catch((err: Error) => createErr(err));

/** 削除 */
export const deleteTask = async (id: number): Promise<Result<null, Error>> =>
  axios
    .delete(constructUrl(`${TASK_URL}/${id}`))
    .then(() => createOk(null))
    .catch((err: Error) => createErr(err));

/** 更新 */
export const editTask = async (
  id: number,
  payload: ReleaseTask,
): Promise<Result<ReleaseTask, Error>> =>
  axios
    .put(constructUrl(`${TASK_URL}/${id}`), payload)
    .then(({ data }) => createOk(data))
    .catch((err: Error) => createErr(err));
